import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const useSortQueryState = () => {
    const { state: sortQueryValue, setState: setSortQueryState } = useNuqsQueryState(
        EventJournalQueries.sort
    );

    const clearSortQueryState = () => {
        void setSortQueryState(null);
    };

    return {
        sortQueryValue,
        setSortQueryState,
        clearSortQueryState,
    };
};
